import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fmt = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n ?? 0);

export const discountOf = (p) =>
  p?.reference_price && p.reference_price > p.price
    ? Math.round((1 - p.price / p.reference_price) * 100)
    : 0;

export const fileUrl = (path) => `${API}/files/${path}`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Une erreur est survenue, réessaie.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return String(d);
};
